import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  id?: string;
  text: string;
  size?: string;
  className?: string;
  icon?: IconProp;
  outline?: boolean;
  color?: string;
  disabled?: boolean;
  active?: boolean;
  children?: React.ReactNode;
}

const CustomDropDown: React.FC<Props> = ({
  id,
  text,
  size,
  className,
  icon,
  children,
  outline = true,
  color = 'primary',
  disabled,
  active,
}) => {
  const classes = `${className || ''} ${icon ? 'icon' : ''}`;

  return (
    <UncontrolledDropdown size={size} className={classes}>
      <DropdownToggle
        id={id}
        className={`${active ? 'active ' : ''}${icon ? 'icon' : ''}`}
        outline={outline}
        color={color}
        disabled={disabled}
      >
        {/* <p> */}
        {icon && <FontAwesomeIcon icon={icon} key="left" />}
        {text}
        <FontAwesomeIcon icon="chevron-down" key="right" />
        {/* </p> */}
      </DropdownToggle>
      <DropdownMenu className="dropdown__menu">
        <div className="dropdown_custominner">{children}</div>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default CustomDropDown;
